import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FiltersButton from "../common/FiltersButton";
import { Box } from "@mui/material";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

export const CustomAdminLayout = ({
    children,
    title,
    showCreateButton = false,
    createOnClick,
    createButtonText,
    showSearchInput = false,
    onSearch,
    searchPlaceholder,
    showFilter,
    onFilterClick,
    filterCount,
    height,
    showToggleSwitchElm = false,
    toggleSwitchElm,
    isNotAdmin = false,
}) => {
    const { getFontSize, getContainerHeight, getButtonStyle } =
        useResponsiveStyles();
    return (
        <div className="bg-white pt-1 text-left text-gray-600 rounded-sm">
            <div className="flex justify-between px-2">
                <div>
                    <h2
                        className="font-bold text-primary"
                        style={getFontSize("sub-heading")}
                    >
                        {title}
                    </h2>
                </div>
                <div>
                    <div className="flex items-center">
                        {showSearchInput && (
                            <div className="relative mr-4">
                                <input
                                    type="text"
                                    placeholder={searchPlaceholder}
                                    style={{
                                        ...getContainerHeight("filter-height"),
                                        ...getFontSize("body1"),
                                    }}
                                    className="w-[180px] xl:w-[180px] 2xl:w-[180px] 3xl:w-[200px] xl:text-xs 2xl:text-sm 3xl:text-base rounded-md border border-gray-300 py-1 pl-8 pr-3 italic outline-none focus:border-[#ef4444] focus:ring-1 focus:ring-[#ef4444]"
                                    onChange={(e) => {
                                        onSearch(e.target.value);
                                    }}
                                />
                                <SearchIcon
                                    fontSize="small"
                                    className="absolute left-2 top-1/2 -translate-y-1/2 transform text-gray-400"
                                />
                            </div>
                        )}
                        {showToggleSwitchElm && (
                            <div className="mr-3">{toggleSwitchElm}</div>
                        )}

                        {showFilter && (
                            <Box sx={{ marginRight: 0.9 }}>
                                <FiltersButton
                                    onClick={onFilterClick}
                                    filtersCount={filterCount}
                                />
                            </Box>
                        )}
                        {showCreateButton && (
                            <button
                                className="flex items-center gap-2 rounded-lg bg-primary px-5 py-1.5 text-white"
                                style={{
                                    ...getButtonStyle("create-button"),
                                    ...getFontSize("body1"),
                                }}
                                onClick={createOnClick}
                            >
                                <AddCircleOutlineIcon
                                    style={getFontSize("heading")}
                                />
                                {createButtonText.toUpperCase()}
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <div
                className={
                    height
                        ? height
                        : isNotAdmin
                        ? "h-[calc(100vh-7rem)]"
                        : "h-[calc(100vh-6rem)]"
                }
                style={{ paddingLeft: "0.9rem", paddingRight: "0.9rem" }}
            >
                {children}
            </div>
        </div>
    );
};
